<template lang="html">
  <div>
    <h3>Seja bem vindo ao Portal do Usuário</h3>
    <p>Que bom vê-lo novamente aqui!</p>
    <form
      ref="loginForm"
      @submit.prevent="onSubmit"
      @keydown.enter.prevent="onSubmit">
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        {{ error.message }}
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-user" />
          </div>
          <input
            type="email"
            class="form-control"
            ref="email"
            placeholder="Email"
            autocomplete="email"
            v-model="email"
            required>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            id="password"
            type="password"
            ref="password"
            autocomplete="current-password"
            class="form-control"
            placeholder="Senha de acesso"
            v-model="password"
            required>
          <span class="input-group-append">
            <a
              class="input-group-text"
              href="#"
              @click.prevent="togglePasswordVisibility()">
              <i class="ik ik-eye" />
            </a>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <a
            href="#"
            class="recover-password btn btn-secondary btn-light"
            @click.prevent="openForgetPasswordModal">Esqueceu a senha?</a>
        </div>
      </div>
      <div class="sign-btn text-center">
        <button
          type="submit"
          class="btn btn-primary">
          Entrar
        </button>
      </div>
    </form>
    <div class="register">
      <p>
        Você ainda não possui uma conta?
        <a
          href="#"
          class="signup btn btn-success"
          @click.prevent="goToSignup">
          Crie uma conta
        </a>
      </p>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="forgotPassword"
      ref="forgotPassword"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Fique tranquilo!</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Informe seus dados para recuperar sua senha!</p>
            <form
              ref="forgotPasswordForm"
              class="forgot-form">
              <div
                v-if="recoverError"
                class="alert alert-danger"
                role="alert">
                {{ recoverError.message }}
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-mail" />
                  </div>
                  <input
                    type="email"
                    class="form-control"
                    ref="recoverEmail"
                    placeholder="Informe seu email"
                    v-model="recoverEmail"
                    @keydown.enter="sendRecoverEmail"
                    required>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Esquece, lembrei!</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="sendRecoverEmail">Enviar email de recuperação</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successNotifier"
      ref="successNotifier"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-success">{{ successNotifierMessage }}</p>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: null,
      password: null,
      error: null,
      recoverError: null,
      recoverEmail: null,
      successNotifierMessage: ''
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$refs.email.focus()
      if (this.$route.query && this.$route.query.accessTokenExpired === true) {
        this.error = { message: 'Sua sessão expirou, por favor faça login novamente' }
      }
      if (this.$route.query && this.$route.query.openPasswordRecover === 'true') this.openForgetPasswordModal()
      if (this.$route.query && this.$route.query.emailVerified === 'true') {
        this.successNotifierMessage = 'Parabéns! Seu email foi confirmado com sucesso!'
        $(this.$refs.successNotifier).modal('show')
      }
      if (this.$route.query && this.$route.query.emailAlreadyVerified === 'true') {
        this.successNotifierMessage = 'Seu email já foi confirmado, faça login se souber a senha ou utilize o "Esqueceu a senha?" para redefini-la.'
        $(this.$refs.successNotifier).modal('show')
      }
      if (this.$route.query && this.$route.query.email) {
        this.email = this.$route.query.email
        this.$refs.password.focus()
      }
    })
  },
  methods: {
    onSubmit () {
      const form = this.$refs.loginForm
      this.error = null
      if (form.checkValidity()) {
        let loginBody = { password: this.password, email: this.email }
        this
          .$store
          .dispatch('auth/signIn', loginBody)
          .then(() => {
            this.$router.push(this.$route.query.redirect || {name: 'dashboard'})
          })
          .catch(err => {
            this.parseError(err, errorMessage => {
              this.error = { message: errorMessage }
            })
          })
      } else {
        if (this.email.indexOf('@') === -1) {
          this.error = { message: 'Para fazer o login você precisa informar um email válido' }
        } else {
          this.error = { message: 'Por favor, verifique o email e senha inseridos e tente novamente' }
        }
      }
    },
    sendRecoverEmail () {
      const form = this.$refs.forgotPasswordForm
      this.recoverError = null
      if (form.checkValidity()) {
        this
          .$store
          .dispatch('auth/rememberPassword', this.recoverEmail)
          .then(() => {
            $(this.$refs.forgotPassword).modal('hide')
            this.successNotifierMessage = 'Email enviado com sucesso! Por favor, verifique sua caixa de entrada ou spam.'
            $(this.$refs.successNotifier).modal('show')
          })
          .catch((err) => {
            this.parseError(err, errorMessage => {
              this.recoverError = { message: errorMessage }
            })
          })
      } else {
        this.recoverError = {
          message: 'Por favor, verifique o email e senha inseridos e tente novamente'
        }
      }
    },
    goToSignup () {
      this.$router.push({name: 'signup', params: this.$route.query})
    },
    parseError (error, cb) {
      let errorMessage = 'Oops! Ocorreu algo inesperado :( porfavor entre em contato com suporte@api4com.com'
      if (error) {
        if (error.message) errorMessage = error.message
        if (error.code === 'EMAIL_NOT_FOUND') errorMessage = 'Não encontramos seu email em nossa base, verifique o email digitado e tente novamente'
        if (error.code === 'LOGIN_FAILED') {
          if (this.email.indexOf('@') === -1) {
            errorMessage = 'Para fazer o login você precisa informar um email válido'
          } else {
            errorMessage = 'Por favor, verifique o email e senha inseridos e tente novamente'
          }
        }
        if (error.code === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED' || error.code === 'RESET_FAILED_EMAIL_NOT_VERIFIED') errorMessage = 'Você ainda não confirmou seu email ou está bloqueado, verifique sua caixa de entrada ou spam e clique no link de confirmação ou entre em contato com um dos Administradores da sua Organização'
      }
      cb(errorMessage)
    },
    openForgetPasswordModal () {
      this.recoverEmail = null
      this.recoverError = null
      $(this.$refs.forgotPassword).on('shown.bs.modal', function () {
        this.querySelector('.forgot-form input[type="email"]').focus()
      }).modal('show')
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    },
    onModalOk () {
      this.$router.push(this.$route.query.redirect || {name: 'dashboard'})
    }
  },
  watch: {
    email: function (value) {
      this.email = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/Login.vue